import { Col, Row } from 'antd';
import { TitleBar } from './TitleBar';

export const TitleLayout = ({ isbar=true, children }) => {
  return (
    <Row>
      <Col span={24} className='layout-title'>
        {isbar && <><TitleBar /> &nbsp;</>}<span className='layout-title-label'>{children}</span>
      </Col>
    </Row>
  )
}